import { render, staticRenderFns } from "./wdhdyy.vue?vue&type=template&id=060ce657&scoped=true&"
import script from "./wdhdyy.vue?vue&type=script&lang=js&"
export * from "./wdhdyy.vue?vue&type=script&lang=js&"
import style0 from "./wdhdyy.vue?vue&type=style&index=0&id=060ce657&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060ce657",
  null
  
)

export default component.exports